import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 17a3.5 3.5 0 0 1-3.5-3.5v-.379a3.88 3.88 0 0 1 3.88-3.879h7.69l-1.535-1.535a1 1 0 0 1 1.414-1.414l3.243 3.243a1 1 0 0 1 0 1.414l-3.242 3.242a1 1 0 1 1-1.414-1.415l1.535-1.534-7.692-.001A1.88 1.88 0 0 0 6.5 13.121v.38A1.5 1.5 0 0 0 8 15a1 1 0 1 1 0 2",
      clipRule: "evenodd"
    }
  )
);
var SvgTransferFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TransferFilled_default = SvgTransferFilled;

export { TransferFilled_default as default };
